// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"620":"2eb90be8","679":"430a8d44"}[chunkId] + ".css";
};